/**
 * Дисклеймер о характере разборов.
 *
 * Юридически он защищает не от закона о рекламе (её мы пока не даём), а от претензии
 * «вы ввели меня в заблуждение»: поэтому стоит там, где мы делаем утверждения, — в конце
 * натальной карты и совместимости, — а не всплывающим окном при входе (решение основателя,
 * docs/legal.md §6). Галочки под ним быть не должно: галочка превращает уведомление
 * в согласие, а согласие у нас отдельное (§4.3).
 *
 * Живёт в контрактах, потому что текст один на бэкенд (тексты разборов) и фронт (экран
 * «О Луне»): разъехаться двум копиям тут нельзя — это юридически значимая формулировка.
 */
export const READING_DISCLAIMER =
  'Разбор носит развлекательный характер. Это не медицинская, не психологическая, не юридическая и не финансовая консультация — и не замена ни одной из них.'
